import { css } from '@emotion/react'
import React, { Component } from "react"
import { withThemeProps } from '@findep/microfronts-core';
import { Grid, Container, Backdrop,Snackbar } from "@material-ui/core"
import { Alert } from '@material-ui/lab';
import CircularProgress from '@material-ui/core/CircularProgress';

const bDrop = css`  
    z-index:9999;
    color: '#fff';
  `
class Loading extends Component {

    render() {        
        const{
            bd_open,
            cmp_alert,
            mensaje, 
            color
        }=this.props
        return (
            <Container justify="center" >
                <Grid container justify="center">
                    <Backdrop css={bDrop} open={bd_open} >
                        <CircularProgress color="primary" />
                    </Backdrop>
                    <Snackbar open={cmp_alert} autoHideDuration={6000} onClose={() => this.setState({ cmp_alert: false })}>
                        <Alert variant="filled" severity={color} onClose={() => this.setState({ cmp_alert: false })}>
                            {mensaje}
                        </Alert>
                    </Snackbar>
                </Grid>
            </Container>
        )
    }
}

export default withThemeProps(Loading, 'VDPNLoading')
